import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  withStyles,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

import {
  chartType,
  dataTableLabel,
  languageType,
} from "../../../model/DataGraph";

const StyledTableHeader = withStyles((theme) => ({
  head: {
    backgroundColor: "#3f51b5",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

/**
 * グラフデータ一覧コンポーネント.
 *
 * @param {string} chart グラフ種別(product/shot)
 * @param {string} type グラフ種別(X/Y)
 * @param {object} data グラフデータ
 * @return {object} コンポーネント
 */
// refは使用しないがforwardRefの第2引数として必要
// eslint-disable-next-line no-unused-vars
const ChartTable = React.forwardRef((props, ref) => {
  // 引数
  const {
    // グラフ種別(product/shot)
    chart,
    // グラフ種別(X/Y)
    type,
    // グラフデータ
    data,
  } = props;

  // 表示言語
  const language = languageType.ja;

  let useData = [];
  if (chart === chartType[1].value) {
    useData = data;
  } else if (chart === chartType[0].value) {
    useData = data.filter((record) => record.dataCount > 100);
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label={`${chart}-${type}-table`}>
        {chart === chartType[1].value ? (
          <>
            <TableHead>
              <TableRow>
                <StyledTableHeader align="center">
                  {dataTableLabel.partNo[language]}
                </StyledTableHeader>
                <StyledTableHeader align="center">
                  {dataTableLabel.shot[language]}
                </StyledTableHeader>
                <StyledTableHeader align="center">
                  {dataTableLabel.eccentricity[language](type)}
                </StyledTableHeader>
                <StyledTableHeader align="center">
                  {dataTableLabel.load[language]}
                </StyledTableHeader>
              </TableRow>
            </TableHead>
            {useData.length ? (
              <TableBody>
                {useData.map((row) => (
                  <TableRow key={`row-${chart}-${type}-${row.productId}`}>
                    <TableCell align="center">{row.productId}</TableCell>
                    <TableCell align="center">{row.dataCount}</TableCell>
                    <TableCell align="center">{row.eccentricity}</TableCell>
                    <TableCell align="center">{row.totalLoad}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                </TableRow>
              </TableBody>
            )}
          </>
        ) : (
          <>
            <TableHead>
              <TableRow>
                <StyledTableHeader align="center">
                  {dataTableLabel.shot[language]}
                </StyledTableHeader>
                <StyledTableHeader align="center">
                  {dataTableLabel.eccentricity[language](type)}
                </StyledTableHeader>
                <StyledTableHeader align="center">
                  {dataTableLabel.load[language]}
                </StyledTableHeader>
              </TableRow>
            </TableHead>
            {useData.length ? (
              <TableBody>
                {useData.map((row) => (
                  <TableRow
                    key={`row-${chart}-${type}-${row.eccentricity}-${row.totalLoad}`}
                  >
                    <TableCell align="center">{row.dataCount}</TableCell>
                    <TableCell align="center">{row.eccentricity}</TableCell>
                    <TableCell align="center">{row.totalLoad}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                </TableRow>
              </TableBody>
            )}
          </>
        )}
      </Table>
    </TableContainer>
  );
});

ChartTable.propTypes = {
  chart: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.number,
      dataCount: PropTypes.number.isRequired,
      totalLoad: PropTypes.number.isRequired,
      eccentricity: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
};

export default ChartTable;
